import {CApiNotification} from './CApiNotification';

import type {JsonObject} from '../../../../HeliportJS/dist/models/json';
export class CItemPropertyApiNotification {
  addPosChannelEvent(fn: (params: JsonObject) => void) {
    CApiNotification.addEventListener('PositionChannel', 'ItemProperty', fn);
  }

  addPersonalEvent(fn: (params: JsonObject) => void) {
    CApiNotification.addEventListener('Personal', 'ItemProperty', fn);
  }

  addWorldEvent(fn: (params: JsonObject) => void) {
    CApiNotification.addEventListener('World', 'ItemProperty', fn);
  }
}
